const initialvalues = {
    payment: "",
    setOwnerDetailsbyRadio: [],
    setfilterOwnerDetailsbyRadio: [],
    setDueDetails: [],
    bakFlag: false,
    backFlag1: "fresh",
    formikValues: {}
}

export default function CellTowerReducer(details = initialvalues, action) {
    switch (action.type) {
        case
            "PAYMENTCELL": return { ...details, payment: action.payload };
        case
            "SETOWNERDETAILSBYRADIOCELL": return { ...details, setOwnerDetailsbyRadio: action.payload };
        case
            "SETFILTEROWNERDETAILSBYRADIOCELL": return { ...details, setfilterOwnerDetailsbyRadio: action.payload };
        case
            "SETDUEDETAILSCELL": return { ...details, setDueDetails: action.payload };
        case
            "FORMIKVALUESCELL": return { ...details, formikValues: action.payload };
        case
            "BACKFLAGCELL": return { ...details, bakFlag: action.payload };
        case
            "BACKFLAG1CELL": return { ...details, bakFlag1: action.payload };
        default: return details;
    }
}